// @ts-nocheck
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useAuth, useUser, useClerk, useOrganization } from '@/auth/clerkShim'
import { useNavigate, useLocation, Link, useRoutes, Outlet } from 'react-router-dom';

function BaseLayout() {
  const { orgSlug, isSignedIn, isLoaded } = useAuth();
  const navigate = useNavigate();

  if (!isSignedIn) {
    navigate('/sign-in');
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Outlet context={{ leagueName: orgSlug }} />
    </div>
  );
}

export default BaseLayout;